import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './Auth';

const Header = () => {
  const location = useLocation();
  const { user, signIn, signOut } = useAuth();
  const isHome = location.pathname === '/';

  return (
    <header className="main-header">
      <div className="header-container">
        {/* Logo only */}
        <div className="header-brand">
          <div className="logo">
            <img 
              src="/drilldocs-logo.svg" 
              alt="DrillDocs Logo" 
              className="logo-icon"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{display: 'none', fontWeight: 'bold', fontSize: '20px', color: '#4a4a4a'}}>DrillDocs</div>
          </div>
        </div>

        {/* Home Link - always show on non-home pages */}
        {!isHome && (
          <nav className="header-nav">
            <a href="/" className="nav-link">← Back</a>
          </nav>
        )}

        {/* User Actions */}
        <div className="header-actions">
          {user ? (
            <div className="user-menu">
              <span className="user-name">Welcome, {user.name}</span>
              <button onClick={signOut} className="sign-out-btn">
                Sign Out
              </button>
            </div>
          ) : (
            <button onClick={signIn} className="sign-in-btn">
              Sign in with Google
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;